export const environment = {
  production: true,
  testMode: false,
  domain: 'br.internal.sparbankensyd.se',
  rtUrl: 'https://br.internal.sparbankensyd.se/interests',
  authServiceUrl: 'https://br.internal.sparbankensyd.se/service',
  apiUrl: 'https://br.internal.sparbankensyd.se/api',
  datastoreUrl: 'https://br.internal.sparbankensyd.se/kalp'
}
